import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/global.css';
import './styles/crew.css';
import { usePwaRegister } from './pwa/register';
import { ErrorBoundary } from './components/ErrorBoundary';

function Root() {
  usePwaRegister();
  return (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
